import useRestaurantUuid from './useRestaurantUuid';
import useRestaurantOptions from './useRestaurantOptions';

export default function useRestaurantTimezone() {
  const restaurantUuid = useRestaurantUuid();
  const restaurantOptions = useRestaurantOptions();
  const restaurantOption = restaurantOptions.find(restaurant => restaurant.value === restaurantUuid);
  const timezone = restaurantOption?.timezone;
  
  return typeof timezone === 'string' && timezone !== 'select' ? timezone : null;
}
